import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { RouterMain } from 'routes/router';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { AmbienteEnv, VariaveisAmbiente } from 'ambiente';
import { EnumDeviceType } from 'ambiente/ambiente-tipos';
import './assets/css/join.css';

const queryCache = new QueryCache({
  defaultConfig: {
    mutations: {
      useErrorBoundary: false,
      throwOnError: false,
    },
    queries: {
      retry: 1,
      refetchOnMount: false,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      useErrorBoundary: true,
    },
  },
});

const SwitchRouter = ({ children }: any) => {
  const insertScriptCheckout = () => {
    const script = document.createElement('script');
    script.type = "text/javascript"
    script.src =
      AmbienteEnv === 'devWeb' ?
        process.env.REACT_APP_CHECKOUT_URL_DEV! :
        process.env.REACT_APP_CHECKOUT_URL_PROD!;
    document.head.appendChild(script);
  };

  useEffect(() => {
    insertScriptCheckout();
  }, [])

  if (VariaveisAmbiente.deviceType === EnumDeviceType.CORDOVA) {
    return (
      <HashRouter>
        {children}
      </HashRouter>
    )
  }

  return (
    <BrowserRouter>
      {children}
    </BrowserRouter>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <ReactQueryCacheProvider queryCache={queryCache}>
      <SwitchRouter>
        {/* {VariaveisAmbiente.isDev && <ReactQueryDevtools initialIsOpen={false} />} */}
        <RouterMain />
      </SwitchRouter>
    </ReactQueryCacheProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
